import React from 'react';
import catering from '../assets/icons/catering.svg';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux'
import { withSnackbar } from 'react-simple-snackbar'
import * as actions from '../store/actions/index';
import { useEffect } from 'react';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable from 'react-data-table-component';

const Invoices = (props) => {
    const { getInvoiceData,invoidelisting } = props
    useEffect(() => {
        getInvoiceData()
    }, [getInvoiceData])
    console.log(props.invoidelisting)
    const columns = [
        {
            name: 'Amount',
            selector: row => row.amount,
            sortable: true
        },
        // {
        //     name: 'customer Email',
        //     selector: row => row.customerEmail,
        //     sortable: true
        // },
        {
            name: 'description',
            selector: row => row.description,
            sortable: true
        },
        {
            name: 'Reciept',
            selector: row => <a href={row.receipt_url} target='_blank' rel="noreferrer">Link</a>,
            sortable: true
        },
        
        // {
        //     name: 'amount',
        //     selector: row => row.amount,
        //     sortable: true
        // },
        {
            name: 'Card',
            selector: row => '******'+ row.source.last4,
            sortable: true
        },
        // {
        //     name: 'ratedBusiness',
        //     selector: row => row.ratedBusiness,
        //     sortable: true
        // },
        // {
        //     name: 'paymentMethod',
        //     selector: row => row.paymentMethod,
        //     sortable: true
        // },
        {
            name: 'status',
            selector: row => row.status,
            sortable: true
        },
        
    ];
    return (
        <div className='business-details-page py-4 py-xl-5'>
            {/* title head */}
            <Helmet>
                <title>CouponRanking | Invoice Details</title>
            </Helmet>
            <ToastContainer />
            <div className='container'>
                <div className='section-label fs-1 mb-4'>Invoice Details</div>
                <form className='bg-light px-3 px-md-5 py-4 py-md-5'>
                    <div className="row gx-3">
                        <div className="col-sm-6">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="bWebsite">Plan Name - </label>
                                <label className="form-label" htmlFor="bWebsite"> {props.getData.length > 0 ? props.getData[0].PlanName: ""}</label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="perClick">Total number of click</label>
                                <label className="form-label" htmlFor="bWebsite"> {props.getData.length > 0 ? props.getData[0].totalClickCount: ""}</label>
                            </div>
                        </div>
                    </div>
                    <div className="row gx-3">
                        <div className="col-sm-6">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="bWebsite">Time Period - </label>
                                <label className="form-label" htmlFor="bWebsite"> {props.getData.length > 0 ? props.getData[0].subscriptionTimePeriod.name: ""}</label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="perClick">Amount of membership - </label>
                                <label className="form-label" htmlFor="bWebsite"> 399$</label>
                            </div>
                        </div>
                    </div>
                    <div className="row gx-3">
                        <div className="col-sm-4">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="bWebsite">Total amount of lead - </label>
                                <label className="form-label" htmlFor="bWebsite"> {props.getData.length > 0 ? props.getData[0].totalClickAmount: ""}</label>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="perClick">Total amount of lead - </label>
                                <label className="form-label" htmlFor="bWebsite"> {props.getData.length > 0 ? props.getData[0].currentMonthClickAmount.toFixed(2): ""}</label>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="perClick">Cost per month :- </label>
                                <label className="form-label" htmlFor="bWebsite"> {props.getData.length > 0 ? props.getData[0].currentMonthClickCount: ""}</label>
                            </div>
                        </div>
                    </div>
                    <div className="row gx-3">
                        {props.invoidelisting?.length > 0 ? (
                            <DataTable
                                columns={columns}
                                data={props.invoidelisting}
                                pagination
                                highlightOnHover
                                striped
                            />
                        ) : (
                            <div className='fs-3 text-danger text-center'>
                                There is no business in your area!
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapPropsToState = (state) => {
    return {
        loading: state.business.loading,
        error: state.business.error,
        success: state.business.success,
        getData: state.business.getData,
        invoidelisting: state.business.invoidelisting
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCategoryList: () => dispatch(actions.getCategoryList()),
        getPlanDetailOfUser: () => dispatch(actions.getPlanDetailOfUser()),
        getInvoiceData: (data) => dispatch(actions.getInvoiceData(data))
    }
}

export default connect(
    mapPropsToState,
    mapDispatchToProps
)(withSnackbar(Invoices))
